import React, { useState } from "react";
import styled from "styled-components";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import MatchSummary from "./MatchSummary";

const getPositionCSSClass = (position, lastPosition) => {
  var playerPosition = "";
  if (position === 1) {
    playerPosition = "pos-1";
  }
  if (position === 2 || position === 3) {
    playerPosition = "pos-promotion";
  }
  if (position === lastPosition - 1 || position === lastPosition - 2) {
    playerPosition = "pos-playoff-descent";
  }
  if (position === lastPosition) {
    playerPosition = "pos-last";
  }
  return playerPosition;
};

const GroupRow = (player) => {
  const [matchesDetail, setMatchesDetail] = useState(false);
  const cssPosition = getPositionCSSClass(player.position, player.lastPosition);

  if (player.username === "DESCANSA") {
    return "";
  }

  return (
    <Wrapper>
      <>
        <div className="row" onClick={() => setMatchesDetail(!matchesDetail)}>
          <div className={`position ${cssPosition}`} />
          <div className="x1">{player.position}</div>
          <div className="x3">{player.username}</div>
          <div className="x2">{player.points ? player.points : 0}</div>
          <div className="x2">{`${player.seriesWin ? player.seriesWin : 0} - ${
            player.seriesLoose ? player.seriesLoose : 0
          }`}</div>
          <div className="x2">{`${player.mapsWin ? player.mapsWin : 0} - ${
            player.mapsLoose ? player.mapsLoose : 0
          }`}</div>
          <div className="x3 matches-history">
            {player.history
              ? player.history.map((match, index) => {
                  if (match.phase !== "REGULAR_LEAGUE") {
                    return "";
                  }
                  var match_result = "hidden";
                  var match_result_summary = "?";

                  if (match.status === "NOT_STARTED") {
                    match_result = "not-played";
                  }

                  if (
                    match.status === "FINISHED" ||
                    match.status === "REVIEWED"
                  ) {
                    if (
                      player.playerId === match.playerAid &&
                      match.playerAresult > match.playerBresult
                    ) {
                      match_result = "win";
                      match_result_summary = match.playerAresult;
                    } else if (
                      player.playerId === match.playerBid &&
                      match.playerBresult > match.playerAresult
                    ) {
                      match_result = "win";
                      match_result_summary = match.playerBresult;
                    } else {
                      match_result = "defeat";

                      player.playerId === match.playerAid
                        ? (match_result_summary = match.playerAresult)
                        : (match_result_summary = match.playerBresult);
                    }
                  }

                  if (
                    match.playerAusername === "DESCANSA" ||
                    match.playerBusername === "DESCANSA"
                  ) {
                    match_result = "rest-game";
                    match_result_summary = "-";
                  }

                  return (
                    <div
                      key={`match-${match.matchId}-index`}
                      className={`match ${match_result}`}
                    >
                      {match_result_summary}
                    </div>
                  );
                })
              : ""}
          </div>

          {matchesDetail ? <FaAngleUp /> : <FaAngleDown />}
        </div>
        <div
          className={`matches-history-detail ${
            matchesDetail ? "detail-show" : "detail-hidden"
          }`}
        >
          {player.history
            ? player.history
                .sort((a, b) => (a.leagueDay > b.leagueDay ? 1 : -1))
                .map((match) => {
                  if (match.phase !== "REGULAR_LEAGUE") {
                    return "";
                  }
                  return (
                    <MatchSummary
                      key={`matchsummary-${player.playerId}-${match.matchId}`}
                      {...match}
                    />
                  );
                })
            : ""}
        </div>
        <hr />
      </>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .row {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
  }

  hr {
    border-color: var(--clr-grey-10);
  }
  .x1 {
    width: 2rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x2 {
    width: 6rem;
    margin: 1rem;
    display: flex;
    justify-content: center;
  }

  .x3 {
    width: 28rem;
    margin: 1rem;
  }

  .x4 {
    width: 56rem;
    margin: 1rem;
  }
  .position {
    height: 100%;
    width: 0.5rem;
  }

  .pos-1 {
    background-color: var(--clr-green-dark);
  }

  .pos-promotion {
    background-color: var(--clr-yellow-dark);
  }

  .pos-playoff-descent {
    background-color: var(--clr-red-light);
  }

  .pos-last {
    background-color: var(--clr-red-dark);
  }

  .matches-history {
    display: flex;
  }

  .match {
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    margin: 0.2rem;
  }

  .win {
    background-color: var(--clr-green-dark);
  }

  .defeat {
    background-color: var(--clr-red-dark);
  }

  .not-played {
    background-color: var(--clr-grey-4);
  }

  .rest-game {
    background-color: var(--clr-grey-9);
  }

  .hidden {
    background-color: var(--clr-black);
    border: 1px solid var(--clr-grey-1);
  }

  .matches-history-detail {
  }

  .detail-hidden {
    display: none;
  }

  .detail-show {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 1rem;
  }

  @media (max-width: 600px) {
    .matches-history {
      display: none;
    }

    .x1 {
      width: 2rem;
      margin: 0.5rem;
      display: flex;
      justify-content: center;
    }

    .x2 {
      width: 6rem;
      margin: 0.5rem;
      display: flex;
      justify-content: center;
    }

    .x3 {
      width: 28rem;
      margin: 0.5rem;
    }

    .x4 {
      width: 56rem;
      margin: 0.5rem;
    }
    .position {
      height: 100%;
      width: 0.5rem;
    }
  }
`;

export default GroupRow;
